import React, { useState, useEffect } from "react";
import useProyectos from "../../hooks/useProyectos";
import DataTable from "../../components/DataTable/DataTable";
import Title from "../../components/Form/Title";
import useLogin from "../../hooks/useLogin";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { ReporteProyectoDescargar } from "../../service/reporteProyecto";

/**
 * Reporte por proyecto: resumen de costos (presupuestado/pagado/pendiente) y
 * flujo de efectivo, en un Excel descargable. Usa el mismo listado de
 * proyectos que ya filtra por rol en /proyectos.
 */
export default function Reportes() {
  const { token } = useLogin();
  const dispatch = useDispatch();
  const { loading, Proyectos, ProyectosGetService } = useProyectos();
  const [descargando, setDescargando] = useState(null);

  useEffect(() => {
    dispatch(setTitle("Descargando proyectos"));
    dispatch(showLoader());
    ProyectosGetService(token);
    return () => {};
  }, []);

  useEffect(() => {
    if (Proyectos) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => {};
  }, [Proyectos]);

  const descargar = async (proyecto) => {
    setDescargando(proyecto.id);
    try {
      await ReporteProyectoDescargar(proyecto.uuid ?? proyecto.id, token);
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo descargar", text: error.message });
    } finally {
      setDescargando(null);
    }
  };

  const columns = [
    { field: "nombre", title: "Proyecto" },
    { field: "empresa", title: "Empresa" },
    { field: "productor", title: "Productor" },
    {
      field: "reporte",
      title: "Reporte",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <button
          type="button"
          className="crud-secondary-btn"
          onClick={() => descargar(row)}
          disabled={descargando === row.id}
        >
          {descargando === row.id ? (
            <span className="spinner-boton" aria-hidden="true" />
          ) : (
            <i className="bi bi-file-earmark-excel" aria-hidden="true"></i>
          )}
          {descargando === row.id ? "Generando..." : "Descargar reporte"}
        </button>
      ),
    },
  ];

  return (
    <div>
      <div className="crud-header">
        <Title title="Reportes por proyecto" className="crud-title" />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="crud-card">
            <DataTable tableKey="reportes" loading={loading} columns={columns} data={Proyectos ?? []} />
          </div>
        </div>
      </div>
    </div>
  );
}
